import * as THREE from "three";
import Experience from "../Experience.js";
// import { modeldata } from '../../motion-industries'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

/**
 * Class for retrieving information about items in the scene.
 * @category Experience
 * @subcategory World
 */
export default class itemsInScene {
  /**
   * Constructs the itemsInScene instance.
   */
  constructor() {}

  cleanup() {
    // No event listeners or external dependencies, but ensure proper cleanup of references if needed
    this.scene = null;
}

  /**
   * Extracts and returns information about scene items with BoxGeometry and a part number (pn).
   * @param {THREE.Scene} scene - The Three.js scene to traverse.
   * @returns {Object} An object containing position and rotation data for each identified item.
   */
  getSceneItemsInfo(scene) {
    const sceneInfo = {};

    scene.traverse((object) => {
      // Check if object has a BoxGeometry and a part number (pn)
      if (
        object.isMesh &&
        object.geometry instanceof THREE.BoxGeometry &&
        object.userData.pn
      ) {
        // Initialize world position and quaternion
        const worldPosition = new THREE.Vector3();
        const worldQuaternion = new THREE.Quaternion();
        object.getWorldPosition(worldPosition);
        object.getWorldQuaternion(worldQuaternion);

        // Convert quaternion to Euler angles for JSON
        const worldRotation = new THREE.Euler().setFromQuaternion(
          worldQuaternion
        );

        // Add to the JSON structure
        sceneInfo[object.userData.pn] = {
          position: [worldPosition.x, worldPosition.y, worldPosition.z],
          rotation: {
            x: worldRotation.x,
            y: worldRotation.y,
            z: worldRotation.z,
          },
        };
      }
    });

    return sceneInfo;
  }
}

